export default class Api {
  static baseUrl = "/api";

  static async sendMessage(token, message) {
    try {
      const response = await fetch("/api/verify-recaptcha", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, message }),
      });
      if (response.status === 200) return true;
      else return false;
    } catch (error) {
      console.error("Erreur lors de la vérification de reCAPTCHA :", error);
    }
  }
}
